



































import { Component, Vue, Prop } from 'vue-property-decorator'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'

import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import { required } from 'vuelidate/lib/validators'

@Component
export default class extends Vue {
  @Prop({}) private idModal
  @Prop({}) private titleModal
  @Prop({}) private category
  public $v: Vuelidate

  // Upload File
  public hasFiles = {
    fileName: '',
    fileByte: '',
  }
  @Validate({
    required,
  })
  public fileUpload: any = null
  public get stateFile() {
    return Boolean(this.fileUpload)
  }
  public base64Pdf(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        const hash = e.target.result.split(',')
        this.hasFiles = {
          fileName: input.files[0].name,
          fileByte: hash.length ? hash[1] : '',
        }
      }
      reader.readAsDataURL(input.files[0])
    }
  }
  public onShow() {
    this.fileUpload = null
    this.$v.fileUpload.$reset()
  }
  public upload() {
    this.$v.fileUpload.$touch()
    if (!this.stateFile) {
      return
    }
    const image = {
      name: this.hasFiles.fileName,
      category: this.category,
      fileByte: this.hasFiles.fileByte,
      fileUpload: this.fileUpload,
    }
    GalleryImageModule.postGalleryImage(image)
    this.$root.$emit('bv::hide::modal', this.idModal)
  }
  private file = []
  private formatNames(files) {
    return `${files.length} files selected`
  }
  private deleteName(index) {
    this.file.splice(index, 1)
  }
}
